import React from 'react';
import Switch from 'react-switch';

interface ToggleSwitchProps {
  label: string;
  checked: boolean;
  onChange: () => void;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ label, checked, onChange }) => {
  return (
    <div className="toggle-switch">
      <label className="toggle-switch-label">{label}</label>
      <Switch
        onChange={onChange}
        checked={checked}
        offColor="#888"
        onColor="#0d6efd"
        offHandleColor="#fff"
        onHandleColor="#fff"
        uncheckedIcon={false}
        checkedIcon={false}
        height={20}
        width={48}
        className="react-switch"
      />
    </div>
  );
};

export default ToggleSwitch;
